<template >
<v-col cols="3" class="d-flex justify-begin mb-2">
      <v-btn class="mx-2 gris_medio" @click="exportToCSV">
                   {{$t('general.exportar')}}<span class="material-symbols-outlined">arrow_outward</span>
                </v-btn>
                <v-btn  class="mx-2 gris_medio" @click="importFromCSV">
                 <span class="material-symbols-outlined">arrow_insert</span>  {{$t('general.importar')}}
                  <input
                    type="file"
                    accept=".csv"
                    ref="fileInput"
                    style="display: none;"
                    @change="handleUpload"
                  />
                </v-btn>
              
              </v-col>
  <div style="overflow-x: auto; border-radius: 10px;">
    <table>
        <!-- <caption class="table-header">{{ this.$t('electricidad.peajes_title') }}</caption> -->
        <thead>
          <tr>
            <th class="encabezado">{{ this.$t('electricidad.periodo') }}</th>
            <th class="encabezado" >{{ this.$t('electricidad.pot_contratada') }}</th>
            <th class="encabezado" >{{ this.$t('electricidad.pot_contratada_calderas') }}</th>
            <th class="encabezado" >{{ this.$t('electricidad.pcio_exceso_potencia') }}</th>
            <th class="encabezado">{{ this.$t('electricidad.pot_elec_precio_cerrado') }}</th>
            <th class="encabezado" >{{ this.$t('electricidad.pot_peaje') }}</th>
            <th class="encabezado" >{{ this.$t('electricidad.ai_omie') }}</th>
            <th class="encabezado" >{{ this.$t('electricidad.bi_omie') }}</th>
            <th class="encabezado" >{{ this.$t('electricidad.ai_fijo') }}</th>
            <th class="encabezado" >{{ this.$t('electricidad.bi_fijo') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(periodo, index) in matrixData" :key="index" class="tabla-hover">
            <td class="primera_columna">p{{ index+1 }}</td>

            <!-- Pot. Contratada -->
            <td>
              <input
                type="number"
                v-model.number="periodo.pot_contratada"
                @input="emitChanges"
              />
            </td>

            <!-- Pot. Contratada Calderas eléctricas -->
            <td>
              <input
                type="number"
                v-model.number="periodo.pot_contratada_calderas"
                @input="emitChanges"
              />
            </td>
            <!-- Precio exceso de potencia -->
            <td>
              <input
                type="number"
                v-model.number="periodo.pcio_exceso_potencia"
                @input="emitChanges"
              />
            </td>
            <!-- Potencia a precio de electricidad cerrado -->
            <td>
              <input
                type="number"
                v-model.number="periodo.pot_elec_precio_cerrado"
                @input="emitChanges"
              />
            </td>

            <!-- Peaje Pot. -->
            <td>
              <input
                type="number"
                v-model.number="periodo.peaje_pot"
                @input="emitChanges"
              />
            </td>

            <!-- Ai OMIE Abierto -->
            <td>
              <input
                type="number"
                v-model.number="periodo.ai_omie_abierto"
                @input="emitChanges"
              />
            </td>

            <!-- Bi OMIE Abierto -->
            <td>
              <input
                type="number"
                v-model.number="periodo.bi_omie_abierto"
                @input="emitChanges"
              />
            </td>

            <!-- Ai Fijo Cerrado -->
            <td>
              <input
                type="number"
                v-model.number="periodo.ai_fijo_cerrado"
                @input="emitChanges"
              />
            </td>

            <!-- Bi Fijo Cerrado -->
            <td>
              <input
                type="number"
                v-model.number="periodo.bi_fijo_cerrado"
                @input="emitChanges"
              />
            </td>
          </tr>
        </tbody>

      </table>

      <v-dialog v-model="showAlert" max-width="400">
                   <v-card>
                     <v-card-title class="headline">Advertencia</v-card-title>
                     <v-card-text>
                      {{ error_msg }}
                     </v-card-text>
                     <v-card-actions>
                       <v-spacer></v-spacer>
                       <v-btn color="primary" text @click="showAlert = false">Close</v-btn>
                     </v-card-actions>
                   </v-card>
                 </v-dialog>

    </div>

    
</template>
<script>


import Papa from 'papaparse';
import Swal from 'sweetalert2';

const HEADERS_OFICIALES_PEAJES = [
  "Periodo",
  "Pot.contratada (MWe)",
  "Pot.contratada calderas eléctricas (MWe)",
  "Precio exceso de potencia (EUR/MWh)",
  "Pot. a precio de electricidad cerrado (MW)",
  "Peaje pot. (EUR/MWe)",
  "Ai OMIE (abierto)",
  "Bi OMIE (abierto)",
  "Ai fijo (cerrado)",
  "Bi fijo (cerrado)"
];
//imports
export default{
    props:{
        elec_peajes:{
            type:Object,
            required:true,
        },
    },
    data(){
        return{
              error_msg:"",
             showAlert:false,
             matrixData : [
                    ...this.elec_peajes
                ],
                //Pot.contratada calderas eléctricas (MWe)

                columns:[
                { name: "Periodo", prop: "periodo", size: 110, readonly:true },
                
                { name: "Pot.contratada (MWe)", prop: "pot_contratada", size: 200 },
                { name: "Pot.contratada calderas eléctricas (MWe)", prop: "pot_contratada_calderas", size: 200 },
                { name: "Precio exceso de potencia (€/h)", prop: "pcio_exceso_potencia", size: 200 },
                { name: "Pot. a precio de electricidad cerrado (MW)", prop: "pot_elec_precio_cerrado", size: 200 },
                { name: "Peaje pot. (EUR/MWe)", prop: "peaje_pot", size: 200 },
                { name: "Ai OMIE (abierto)", prop: "ai_omie_abierto", size: 169 },
                { name: "Bi OMIE (abierto)", prop: "bi_omie_abierto", size: 168 },
                { name: "Ai fijo (cerrado)", prop: "ai_fijo_cerrado", size: 158 },
                { name: "Bi fijo (cerrado)", prop: "bi_fijo_cerrado", size: 159 }
                    ],
        }
    },
    created(){
       
    },
    watch:{
 
    },
    methods:{
       toCsvDecimalComma(v, fixed = null) {
    if (v === null || v === undefined || v === '') return '';
    const n = Number(v);
    if (Number.isNaN(n)) return '';
    const s = fixed != null ? n.toFixed(fixed) : String(n);
    return s.replace('.', ',');
  },
      /* Formatea el número a dos decimales solo para la visualización
      formatDecimal(value) {
        return value ? Number(value).toFixed(2) : "0.00";
      },

      // Actualiza el valor 
      updateValue(index, field, value) {
        const newValue = parseFloat(value).toFixed(2); // Redondear a 2 decimales
        this.matrixData[index][field] = Number(newValue); // Guardar como número

        this.emitChanges(); // Emitir el cambio al padre
      },*/

      emitChanges(){
        this.$emit("update:elec_peajes", this.matrixData);
      },
        exportToCSV() {
            try {
              const headers = HEADERS_OFICIALES_PEAJES.join(";");

              const rows = this.matrixData.map((row) =>
                [
                  // Periodo tal cual (ej. p1..p6)
                  row.periodo ?? "",
                  // resto: numéricos con coma
                  this.toCsvDecimalComma(row.pot_contratada),
                  this.toCsvDecimalComma(row.pot_contratada_calderas),
                  this.toCsvDecimalComma(row.pcio_exceso_potencia),
                  this.toCsvDecimalComma(row.pot_elec_precio_cerrado),
                  this.toCsvDecimalComma(row.peaje_pot),
                  this.toCsvDecimalComma(row.ai_omie_abierto),
                  this.toCsvDecimalComma(row.bi_omie_abierto),
                  this.toCsvDecimalComma(row.ai_fijo_cerrado),
                  this.toCsvDecimalComma(row.bi_fijo_cerrado),
                ].join(";")
              );

              const csvContent = [headers, ...rows].join("\n");
              const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });
              const url = URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = "precios_peajes.csv";
              a.click();
              URL.revokeObjectURL(url);

              Swal.fire({ icon: 'success', title: 'Exportación correcta', timer: 1600, showConfirmButton: false });
            } catch (e) {
              Swal.fire({ icon: 'error', title: 'Error al exportar', text: e?.message || 'Revisa los datos.' });
            }
          },
            //Llamada a input de CSV
        importFromCSV() {
          this.$refs.fileInput.click();
        },

        //Gestión de subida de archivos CSV
  handleUpload(event) {
  const file = event.target.files[0];
  if (!file) return;

  if (!/\.csv$/i.test(file.name)) {
    Swal.fire({ icon: 'error', title: 'Formato no válido', text: 'Solo se admiten archivos .csv.' });
    event.target.value = '';
    return;
  }

  const start = performance.now();
  const reader = new FileReader();

  reader.onload = (e) => {
    try {
      const data = e.target.result;

      Papa.parse(data, {
        delimiter: ";",
        skipEmptyLines: true,
        header: true,
        complete: (result) => {
          const rows = result.data;
          if (!rows?.length) {
            Swal.fire({ icon: 'error', title: 'CSV vacío', text: 'El CSV está vacío.' });
            event.target.value = '';
            return;
          }

          // ========= Validación de CABECERAS =========
          let columnas = Object.keys(rows[0] || {}).map((h, i) =>
            (i === 0 ? String(h).replace(/^\uFEFF/, '') : String(h)).trim()
          );

          const faltantes = HEADERS_OFICIALES_PEAJES.filter(h => !columnas.includes(h));
          const extrasRaw = columnas.filter(c => !HEADERS_OFICIALES_PEAJES.includes(c));
          // limpiar valores vacíos/espacios
          const extras = extrasRaw.map(x => String(x).trim()).filter(Boolean);
          let desordenadas = [];
          HEADERS_OFICIALES_PEAJES.forEach((h, i) => {
            if (columnas[i] !== h) desordenadas.push(`${h} (posición esperada ${i + 1})`);
          });

          if (faltantes.length || extras.length || desordenadas.length) {
            const seccion = (titulo, arr) =>
              arr.length
                ? `<h4 style="margin:6px 0 2px 0;">${titulo}</h4><ul style="margin:0 0 8px 18px; padding:0;">${arr.map(x => `<li>${x}</li>`).join('')}</ul>`
                : '';

            const html =
              `<div style="text-align:left;">
                 <p>El CSV no respeta la <b>plantilla oficial</b> (encabezados y orden).</p>
                 ${seccion('❌ Faltan', faltantes)}
                 ${seccion('⚠️ Sobran', extras)}
                 ${seccion('🔄 Desordenadas', desordenadas)}
               </div>`;

            Swal.fire({ icon: 'error', title: 'Encabezados incorrectos', html });
            event.target.value = '';
            return; // 
          }
          // ========= Fin validación de CABECERAS =========

          // Validar nº de filas 
          if (rows.length !== 6) {
            Swal.fire({ icon: 'error', title: 'Número de filas incorrecto', text: 'La matriz de datos debe contener 6 filas (una por periodo p1…p6).' });
            event.target.value = '';
            return;
          }

          // ========= Validación por FILA  =========
          const erroresFila = [];
          const reqNumericos = [
            ["Pot.contratada (MWe)", "Pot.contratada (MWe)"],
            ["Pot.contratada calderas eléctricas (MWe)", "Pot.contratada calderas eléctricas (MWe)"],
            ["Precio exceso de potencia (EUR/MWh)", "Precio exceso de potencia (EUR/MWh)"],
            ["Pot. a precio de electricidad cerrado (MW)", "Pot. a precio de electricidad cerrado (MW)"],
            ["Peaje pot. (EUR/MWe)", "Peaje pot. (EUR/MWe)"],
            ["Ai OMIE (abierto)", "Ai OMIE (abierto)"],
            ["Bi OMIE (abierto)", "Bi OMIE (abierto)"],
            ["Ai fijo (cerrado)", "Ai fijo (cerrado)"],
            ["Bi fijo (cerrado)", "Bi fijo (cerrado)"],
          ];

          rows.forEach((row, idx) => {
            const fila = idx + 1;
            const periodo = String(row['Periodo'] ?? '').trim();

            if (!periodo) {
              erroresFila.push(`Fila ${fila}: 'Periodo' es obligatorio (p1…p6).`);
            } else if (!/^p[1-6]$/i.test(periodo)) {
              erroresFila.push(`Fila ${fila}: 'Periodo' debe ser p1…p6 (valor actual: "${periodo}").`);
            }

            reqNumericos.forEach(([key, label]) => {
              const val = row[key];
              const num = this.parseNumber?.(val);
              if (val === undefined || val === null || String(val).trim() === '') {
                erroresFila.push(`Fila ${fila}: '${label}' es obligatorio.`);
              } else if (Number.isNaN(num)) {
                erroresFila.push(`Fila ${fila}: '${label}' debe ser numérico (valor actual: "${val}").`);
              }
            });
          });

          if (erroresFila.length) {
            const html =
              `<div style="text-align:left; max-height:45vh; overflow:auto;">
                 <p>Se han detectado errores en los datos:</p>
                 <ul style="margin:0 0 8px 18px; padding:0;">
                   ${erroresFila.map(e => `<li>${e}</li>`).join('')}
                 </ul>
                 <p><small>Corrige los valores indicados y vuelve a importar el CSV.</small></p>
               </div>`;
            Swal.fire({ icon: 'error', title: 'Errores en datos', html, width: 800 });
            event.target.value = '';
            return;
          }
          // ========= Fin validación por FILA =========

          // Construcción de matriz 
          const matrix = rows.map((row) => {
            const periodo = String(row['Periodo']).trim().toLowerCase(); 
            const getNum = (key) => this.parseNumber(row[key]);

            return {
              periodo,
              pot_contratada: getNum("Pot.contratada (MWe)"),
              pot_contratada_calderas: getNum("Pot.contratada calderas eléctricas (MWe)"),
              pcio_exceso_potencia: getNum("Precio exceso de potencia (€/h)"),
              pot_elec_precio_cerrado: getNum("Pot. a precio de electricidad cerrado (MW)"),
              peaje_pot: getNum("Peaje pot. (EUR/MWe)"),
              ai_omie_abierto: getNum("Ai OMIE (abierto)"),
              bi_omie_abierto: getNum("Bi OMIE (abierto)"),
              ai_fijo_cerrado: getNum("Ai fijo (cerrado)"),
              bi_fijo_cerrado: getNum("Bi fijo (cerrado)"),
            };
          });

          this.matrixData = matrix;
          this.emitChanges();

          const end = performance.now();
          console.log(`Tiempo transcurrido: ${end - start} ms`);

          Swal.fire({ icon: 'success', title: 'Importación correcta', text: `${matrix.length} periodos importados.` });
        },
        error: () => {
          Swal.fire({ icon: 'error', title: 'Lectura fallida', text: 'No se pudo leer el CSV.' });
          event.target.value = '';
        }
      });
    } catch (err) {
      // errores inesperados 
      Swal.fire({ icon: 'error', title: 'Error al importar', text: err?.message ?? 'Archivo no válido.' });
    } finally {
      // Limpia el input 
      event.target.value = '';
    }
  };

  reader.readAsText(file, 'utf-8');
},

        handleCellEdit(event){
            console.log("Intercepta...");
            if (!event || !event.detail) {
                console.error("El evento o el detalle no están definidos correctamente.");
                return;
            }
            // Acceder al detalle del evento
            const { detail } = event;

            
            let newValue = Number(detail.val);
            let newValueSTR = String(detail.val).replace(',', '.'); // Reemplaza la coma por punto
            newValue = isNaN(newValueSTR) ? null : Number(newValueSTR); 
            console.log("newValue : ",newValue, " ", typeof(newValue));
            if (typeof(newValue)!=="number"){
           
            this.showAlert=true;
            }
            // Actualizar el modelo de la fila correspondiente
            const rowIndex = detail.rowIndex;
            this.matrixData[rowIndex][detail.prop] = newValue;
            
            //console.log("tipo: ", typeof(newValue))
            // Confirmación en consola
            console.log(`Fila actualizada (${rowIndex}) (${detail.prop}):`, this.matrixData[rowIndex][detail.prop]);
        },
         parseNumber(value) {
          if (!value) return 0;

          
          value = value.trim();

          
          if (value.includes(',') && !value.includes('.')) {
            value = value.replace(/\./g, '');        
            value = value.replace(',', '.');          
          }

          
          else if (value.includes(',') && value.includes('.')) {
            
            if (value.lastIndexOf(',') > value.lastIndexOf('.')) {
              value = value.replace(/\./g, '');       
              value = value.replace(',', '.');      
            }
            
            else {
              value = value.replace(/,/g, '');        
            }
          }

          

          return parseFloat(value);
        },

        error(n_error){
          
          switch(n_error){
            case 1:
            this.error_msg="Es necesario que el csv contenga las columnas requeridas de Peajes de  Electricidad";
              break;
            case 2:
            this.error_msg="La matriz de datos debe contener 6 filas de datos, una por periodo";
            
              break;
          }
          this.showAlert=true;
        },
    },
}

</script>
<style scoped>
table {
    width: 100%;
    border-collapse: collapse;
    text-align: center;
    border-radius: 10px;
  }
  .table-header {
    font-size: 1.5em;
    font-weight: bold;
    text-align: center;
    margin-bottom: 10px;
    color: white;
    background-color: #006699;
  }
  

  .primera_columna{
    background-color: white;
  }
  .valor_fijo{
    background-color: white;
  }


  
  select {
    width: 100%;
    border: 1px solid #F2F2F2;
    border-radius: 4px;
    text-align: center;
    color: #024e74;
  }
  
  input[disabled] {
    background-color: white;
    color: #024e74;
    cursor: not-allowed;
  }
</style>